import styled from 'styled-components'
import { Link as BaseLink } from 'react-router-dom'
import { Breadcrumbs } from '@material-ui/core'

export const ExtenalLink = styled.a`
  color: ${props => props.theme.palette.brand.gray[50]};
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.palette.brand.gray[30]};
    text-decoration: underline;
  }
`

export const Link = styled(BaseLink)`
  color: ${props => props.theme.palette.brand.gray[50]};
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.palette.brand.gray[30]};
    text-decoration: underline;
  }
`

export const Root = styled(Breadcrumbs)`
  background-color: ${props => props.theme.palette.brand.white};
  color: ${props => props.theme.palette.brand.gray[50]};
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeights[300]};
  line-height: 20px;

  & > ol {
    background-color: ${props => props.theme.palette.brand.white};
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0 0 1rem;
    padding: 0 1rem 0 0;
  }
`

export const Text = styled.span`
  color: ${props => props.theme.palette.brand.gray[50]};
`
